//@ts-ignore
import React, { useState, useEffect } from "react";
import _ from "lodash";
import Divider from "@material-ui/core/Divider";
import {
  Theme,
  createStyles,
  WithStyles,
  Grid,
  withStyles,
  Typography,
  Button,
} from "@material-ui/core";
import { NavLink as RouterLink, Route } from "react-router-dom";
import moment from "moment";
import { connect } from "react-redux";
import { getDiffOnTwoDates } from "../../../utils";
import {
  KEY_ARRAYS,
  OBJECT_DATA,
  QUESTION_CREATE_REPORTS,
  generateIssueReport,
} from "./ReportsServices";
import { bindActionCreators } from "redux";
import { showMsg } from "../../course/actions/loaderAlert";
import DatePicker from "../../common/DatePicker";
import * as XLSX from 'xlsx-js-style';
import SearchBarWithChips from "../../course-Management/common/SearchBarWithChips";
import { SELECT_ALL, SHOW_CHECKBOX } from "../../course-Management/Constants/constants";
import { getClient } from '../../client/ClientServices';
interface QuestionIssueReportProps extends WithStyles<typeof styles> {
  showMsg: any;
  showBackButton?: boolean
}

const styles = (theme: Theme) =>
  createStyles({
    btnExport: {
      background: "#1D7DEA",
      borderRadius: 4,
    },
    calenderIcon: {
      zIndex: 2,
      position: "absolute",
      right: 12,
      marginTop: 10,
    },
    closeBtn: {
      position: "absolute",
      right: 0,
      top: 0,
      height: 60,
      padding: 8,
    },
    datePickerContainer: {
      position: "relative",
      "& input": {
        padding: "12px 15px 11px",
        background: "rgb(255, 255, 255)",
        border: "1px solid rgb(223, 223, 223)",
        boxSizing: "border-box",
        borderRadius: 4,
        width: "100%",
        outline: 0,
      },
      "& .react-datepicker-wrapper": {
        width: "100%",
      },
      "& .react-datepicker__navigation--previous, .react-datepicker__navigation--next": {
        outline: 0,
      },
    },
    iconRoot: {
      fill: theme.palette.text.secondary,
      margin: 0,
      width: "2rem",
      height: "2rem",
    },
    mb2x: {
      marginBottom: theme.spacing.unit * 2,
    },
    marginZero: {
      margin: 0,
    },
    marginTop3x: {
      marginTop: 40,
    },
    reportsFrame: {
      background: "#FFF",
      boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.287534)",
      borderRadius: 4,
    },
    paddingXS: {
      padding: "24px 16px",
    },
    titleText: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 36,
      lineHeight: "16px",
      color: "rgb(51, 51, 51)",
      margin: "16px 0 25px 0",
    },
    pageHeading: {
      paddingBottom: 20,
    },
    label: {
      fontFamily: "Nunito",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 16,
      lineHeight: "22px",
      color: "#333333",
    },
    letterSpaccingXS: {
      letterSpacing: 0.144385,
    },
    marginBottomSM: {
      marginBottom: 8,
    },
    padingSm: {
      padding: "30px 12px 0px",
    },
    cancelBtn: {
      background: "#FFF",
      color: "#1D7DEA",
      width: 132,
      marginRight: 6,
      border: "1px solid #1D7DEA",
      boxSizing: "border-box",
      borderRadius: 2,
      fontWeight: 600,
      fontSize: "0.875rem",
    },
    sendBtn: {
      background: "#1D7DEA !important",
      color: "#fff !important",
      width: 132,
      border: "1px solid #1D7DEA",
      boxSizing: "border-box",
      borderRadius: 2,
      fontWeight: 600,
      fontSize: "0.875rem",
    },
    disableBtn: {
      opacity: 0.4,
    },
    paddingMD: {
      padding: 30,
    },
    chipLabel: {
      fontSize: 16,
      fontWeight: 400,
      marginBottom: 10,
    },
    reportHeader: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: 20,
      lineHeight: "16px",
      color: "rgb(51, 51, 51)",
    },
    backButton: {
      color: "#333",
      fontFamily: "Nunito",
      fontSize: "24px",
      fontWeight: 400,
    },
    backToHome: {
      textDecoration: "none",
      color: "#333",
    },
    dateWarning: {
      color: "red",
      marginLeft: "143px",
    },
    backButtonDiv: {
      display: "flex",
      columnGap: "10px",
      marginBottom: "25px",
    },
    invalidRangeContainer: {
      margin: "5px 0 0 48px",
      alignItems:"center",
    },
    invalidRange: {
      color: "red",
    },
    searchBarChips:{
      height: 'auto',
      '&>div:nth-of-type(1)':{
        border: "1px solid #dfdfdf",
        borderRadius: 4,
        padding: '0 5px',
      },
      '& svg':{
        cursor: 'pointer'
      }
    },
    margin19px: {
      margin: '-19px 0px'
    }
  });

export interface QuestionIssueReportState {
  isOpenCalender: boolean;
}

const QuestionIssueReport = (props: QuestionIssueReportProps) => {
  const { classes, showBackButton = true } = props;
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isOpenCalender, setIsOpenCalender] = useState(false);
  const [clients, setClients] = useState([]);
  const convertDateFormat = (date: Date) => {
    return moment(date).format("YYYY-MM-DD");
  };
  const [selectedClient, setSelectedClient] = useState('');
  const [selectedClientId, setSelectedClientId] = useState([]);
  
  useEffect(() => {
    fetchClients();
  }, [])

  const fetchClients = async () => {
    try {
      const res: any = await getClient('');
      if (((res || {}).responseObject || []).length) {
        let clientList = res.responseObject || [];
        clientList = clientList.filter((userType: any) => (userType.schoolOrg && userType.schoolOrg.id) === QUESTION_CREATE_REPORTS.SCHOOL_ORG.id);
        clientList = [{ name: SELECT_ALL.LABEL, _id: SELECT_ALL.VALUE }, ...clientList];
        setClients(clientList);
      }
    } catch (err) {
      setClients([]);
    }
  }

  const validateDate = () => {
    return (
      !startDate.toString().length ||
      !endDate.toString().length ||
      getDiffOnTwoDates(
        convertDateFormat(startDate),
        convertDateFormat(endDate)
      ) >= 0
    );
  };
  const validations = (): boolean => {
    return !(startDate && endDate && validateDate() && selectedClientId.length);
  };

  const resetDefault = () => {
    setStartDate("");
    setEndDate("");
    setSelectedClient('');
    setSelectedClientId([]);
  };

  const checkForEmptyValue = (value: any) => {
    if (!value) {
      return OBJECT_DATA.NA;
    }
    return value;
  };

  const exportJsonToStyledExcel = (
    sheetData: any,
    headerSize: any,
    fileTitle: any
  ) => {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(sheetData);
    const cellWidths: any[] = Array.from({ length: headerSize }, () => ({ wch: 5 }));
    XLSX.utils.book_append_sheet(workbook, worksheet);
    if (!sheetData.length) {
      return;
    }
    const keys = Object.keys(sheetData[0]);
    keys.forEach((key: string, index: number) => {
      sheetData.forEach((obj: any) => {
        const len = obj[key].length;
        const curr = cellWidths[index].wch;
        cellWidths[index] = { wch: Math.min(Math.max(len + 4, curr), 30) };
      });
    });
    const range = XLSX.utils.decode_range(worksheet['!ref']!);
    for (let column = range.s.c; column <= range.e.c; ++column) {
      const headerCell = XLSX.utils.encode_cell({ r: 0, c: column });
      worksheet[headerCell].s = {
        font: { bold: true, color: { rgb: '000000' } },
        fill: {
          patternType: 'solid',
          fgColor: { rgb: 'FFFF00' },
        },
        alignment: {
          wrapText: false,
        },
      };
    }
    worksheet['!cols'] = cellWidths;
    XLSX.writeFile(workbook, `${fileTitle}.xlsx`);
  };

  const generateReport = () => {
    resetDefault();
    generateIssueReport(
      convertDateFormat(startDate),
      convertDateFormat(endDate),
      selectedClientId
    ).then((res: any) => {
      if(res.statusCode === OBJECT_DATA.SUCCESS_CODE) {
        let {
          responseObject: { data },
        } = res;
        const length = Object.keys(data[0]).length;
        data = rearrangeObjectKeys(data);
        exportJsonToStyledExcel(data, length, 'issues-report');
        props.showMsg(res.responseMessage || OBJECT_DATA.SUCCESS_MESSAGE, OBJECT_DATA.SUCCESS);
        return;
      }
      props.showMsg(res.responseMessage, OBJECT_DATA.ERROR);
    }).catch((error: any) => {
      props.showMsg(error.responseMessage || OBJECT_DATA.ERROR_MESSAGE, OBJECT_DATA.ERROR);
    });
  };

  const rearrangeObjectKeys = (data: any) => {
    let mutated_data = [];
    for (let obj of data) {
      const rearrangedObj: any = {};
      KEY_ARRAYS.forEach(key => {
        if (obj.hasOwnProperty(key)) {
          rearrangedObj[key] = obj[key];
        }
      });
      mutated_data.push(rearrangedObj);
    }
    return mutated_data;
  }

  const handleMultiSelectClient = (optionname: any) => {
    setSelectedClient(optionname);
    const selectedClientId = optionname && optionname.length && optionname.filter((item: any) => item.id !== SELECT_ALL.VALUE).map((item: any) => (item.id));
    setSelectedClientId(selectedClientId);
  }

  return (
    <>
      <Grid
        className={classes.mb2x}
        container
        spacing={8}
        alignItems="center"
        justify="space-between"
      >
        <Grid item xs="auto">
          <Typography variant="h6" className={classes.titleText}>
            Question Issues Report
          </Typography>
        </Grid>
        {}
      </Grid>
      {showBackButton && (<Grid>
        <div className={classes.backButton}>
          <RouterLink exact to="/reports" className={classes.backToHome}>
            <Route
              path="/reports"
              children={({}) => (
                <>
                  <div className={classes.backButtonDiv}>
                    <img src="/assets/svg/left-arrow-1.svg" alt="Back" />
                    Back
                  </div>
                </>
              )}
            />
          </RouterLink>
        </div>
      </Grid>)}
      <Grid>
        <Grid container className={classes.reportsFrame}>
          <Grid item xs={12}>
            <Typography
              variant="h6"
              component="body2"
              className={[classes.reportHeader, classes.paddingXS].join(" ")}
            >
              Reports Details
            </Typography>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <Grid container className={classes.paddingXS} spacing={32}>
              <Grid item xs={8}>
                <Grid container spacing={8}>
                  <Grid item xs={6}>
                    <Grid container alignItems="center">
                      <Grid>Select Reported Date Range for Issues </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid container spacing={8}>
                  <Grid item xs={3}>
                    <Grid container alignItems="center">
                      <Grid item className={classes.label}>
                        From &nbsp;&nbsp;
                      </Grid>
                      <Grid item xs={9} className={classes.datePickerContainer}>
                        <DatePicker
                          dateFormat="dd MMMM yyyy"
                          selected={startDate}
                          maxDate={new Date()}
                          onChange={(date) => {
                            setStartDate(date);
                          }}
                          placeholderText="Select Date"
                          startOpen={isOpenCalender}
                          classes={classes.calenderIcon}
                          id="startDate"
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={3}>
                    <Grid container alignItems="center">
                      <Grid item className={classes.label}>
                        To &nbsp;&nbsp;
                      </Grid>
                      <Grid item xs={9} className={classes.datePickerContainer}>
                        <DatePicker
                          dateFormat="dd MMMM yyyy"
                          selected={endDate}
                          maxDate={new Date()}
                          onChange={(date) => {
                            setEndDate(date);
                          }}
                          placeholderText="Select Date"
                          startOpen={isOpenCalender}
                          classes={classes.calenderIcon}
                          id="endDate"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={6}>
                    <Grid className={classes.margin19px} alignItems="center">
                      <Typography className={classes.label}>Client Name</Typography>
                      <div>
                        <SearchBarWithChips
                          suggestions={(clients || []).map((item: any) => ({ value: item._id, label: item.name, id: item._id }))}
                          placeholderText='Select Client Name'
                          onSelection={handleMultiSelectClient}
                          classes={{ root: classes.searchBarChips }}
                          backspaceRemoves={true}
                          notFound="No Client Found"
                          values={selectedClient}
                          source={SHOW_CHECKBOX}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={6}>
                    <Grid container className={classes.invalidRangeContainer}>
                      {!validateDate() && <Grid item className={classes.invalidRange}>Select smaller start date!</Grid>}
                    </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container alignItems="center">
                  <Button
                    disabled={validations()}
                    onClick={generateReport}
                    color="primary"
                    variant="contained"
                    disableRipple
                  >
                    Download Report
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      showMsg: showMsg,
    },
    dispatch
  );
// @ts-ignore

export default connect(null, mapDispatchToProps)(
  withStyles(styles)(QuestionIssueReport)
);
